import Web3 from "web3";
import { contractAbi, contractAddress } from "./../config";
import { useState, useEffect } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";
import Grid from "@material-ui/core/Grid";
import { useTheme, useMediaQuery } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import red from "@material-ui/core/colors/red";
import green from "@material-ui/core/colors/green";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Header from "./header";

function Connect(props) {
  const theme = useTheme();

  const _xs = useMediaQuery(theme.breakpoints.down(458));
  // const [connected, setConnected] = useState(false);
  const [chainId, setChainId] = useState(null);
  const [method, setMethod] = useState(null);
  const [account, setAccount] = useState(null);
  const [contract, setContract] = useState(null);
  const [totalSupply, setTotalSupply] = useState(0);
  const [displayPrice, setDisplayPrice] = useState(0);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    account && method && fireToast();
  }, [method]);

  useEffect(async () => {
    loadWeb3();
  }, []);

  async function loadWeb3() {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum);
      try {
        loadBlockchainData();
        getCurrentAddressConnected();
        addAccountsAndChainListener();
      } catch (error) {
        console.error(error);
      }
    } else {
      swal(
        "",
        "Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!",
        "error"
      );
    }
  }
  const loadBlockchainData = async () => {
    const contract = new window.web3.eth.Contract(contractAbi, contractAddress);
    setContract(contract);
    const chainId = await window.web3.eth.getChainId();
    setChainId(chainId);
    {
      chainId === 1 ? setMethod("success") : setMethod("error");
    }
    // method && fireToast()

    if (chainId === 1) {
      const totalSupply = await contract.methods.totalSupply().call();
      setTotalSupply(totalSupply);

      const price = await contract.methods.price().call();
      setPrice(price);
      const displayPrice = window.web3.utils.fromWei(price, "ether");
      setDisplayPrice(displayPrice);
      //event will be fired by the smart contract when a new is minted
      contract.events
        .PopPandaMinted()
        .on("data", async function (result) {
          setTotalSupply(result.returnValues[0]);
        })
        .on("error", console.error);
    }
  };

  const getCurrentAddressConnected = async () => {
    try {
      const accounts = await window.ethereum.request({
        method: "eth_accounts",
      });
      if (accounts.length > 0) {
        setAccount(accounts[0]);
        // method && fireToast()
      }
    } catch (error) {
      console.error(error);
    }
  };

  const addAccountsAndChainListener = async () => {
    //this event will be emitted when the currently connected chain changes.
    window.ethereum.on("chainChanged", (_chainId) => {
      window.location.reload();
    });

    // this event will be emitted whenever the user's exposed account address changes.
    window.ethereum.on("accountsChanged", (accounts) => {
      window.location.reload();
    });
  };

  const connectMetaMask = async () => {
    if (window.ethereum) {
      try {
        document.getElementById("connectButton").disabled = true;
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        document.getElementById("connectButton").disabled = false;
        setAccount(accounts[0]);
        method && fireToast();
      } catch (error) {
        if (error.code === 4001) {
          swal("Request to access account denied!", "", "error");
        }
        document.getElementById("connectButton").disabled = false;
      }
    }
  };

  async function mint(mintCount) {
    if (contract) {
      if (chainId === 1) {
        if (mintCount === 0) {
          swal("Minimum mint amount is 1 Pop Panda", "", "info");
        } else {
          try {
            const finalPrice = Number(price) * mintCount;
            await contract.methods
              .mintPopPanda(account, mintCount)
              .send({ from: account, value: finalPrice });
          } catch (error) {
            if (error.code === 4001) {
              swal("Transaction Rejected!", "", "error");
            } else {
              swal("Transaction Failed!", "", "error");
            }
          }
        }
      } else {
        swal("Please switch to mainnet to mint Pop Panda", "", "error");
      }
    } else {
      swal(
        "",
        "Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!",
        "error"
      );
    }
  }
  const fireToast = () => {
    toast[method](
      `You are ${method === "error" ? "not" : ""} connected to mainnet`,
      {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: true,
      }
    );
  };

  return (
    <>
      <Grid
        container
        justifyContent={_xs ? "center" : "space-between"}
        style={{
          paddingTop: "20px",
          paddingBottom: "20px",
        }}
      >
        <span></span>
        <Button
          id="connectButton"
          variant="contained"
          color="default"
          startIcon={
            <FiberManualRecordIcon
              fontSize="small"
              style={{ color: account ? green[500] : red[500] }}
            />
          }
          onClick={connectMetaMask}
        >
          {account
            ? account.slice(0, 8) + "..." + account.slice(account.length - 5)
            : "Connect Wallet"}
        </Button>
      </Grid>
      <Header mint={mint} totalSupply={totalSupply} price={displayPrice} />
    </>
  );
}

export default Connect;
